import React from 'react';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { MarginProps } from '../../../../../theme/styledProps';

interface Props extends MarginProps {
  htmlFor: string;
}

export const Label: React.FC<Props> = ({ children, htmlFor, ...rest }) => {
  return (
    <Text as="label" htmlFor={htmlFor} fontWeight={500} {...rest}>
      {children}
    </Text>
  );
};
